import React, { Component } from 'react';
import { connect } from 'react-redux';
import { dAPI } from 'appSrc/api';
import { Icon } from 'appSrc/components/UI';
import EditCategoryModal from '../../Modals/Category/EditCategoryModal';
import Row from './Row';
import style from './styles/style.module.css';

class CategoriesTable extends Component {
    constructor( props ) {
        super( props );

        this.state = {
            categoryInEdit: null,
            categoryInEditIndex: -1,
            isRowOpen: {},
        };
    }
    updateCategory = ( index, interestid, data ) => {
        this.props.updateCategory( interestid, data )
        .then( ( category ) => {
            return this.props.onCategoryUpdated && this.props.onCategoryUpdated( index, category );
        } );
    }
    openEditModal = ( index, category ) => {
        this.setState( { categoryInEdit: category, categoryInEditIndex: index } );
    }
    onEditSubmit = ( category ) => {
        var index = this.state.categoryInEditIndex;
        this.props.onCategoryUpdated( index, category );
        this.setState( { categoryInEdit: null, categoryInEditIndex: -1 } );
    }
    onEditClose = () => {
        this.setState( { categoryInEdit: null, categoryInEditIndex: -1 } );
    }



    render() {
        const { categories } = this.props;
        const { categoryInEdit } = this.state;

        return (
            <div>
                <ul className={ style.categoriesTable }>
                    { this.arrayTableRows( categories ) }
                </ul>
                { categoryInEdit !== null &&
                    <EditCategoryModal closeModal={ this.onEditClose }
                    onSubmit={ this.onEditSubmit }
                    category={ categoryInEdit } />
                }
            </div>
        );
    }

    renderRow = ( category, parents=[], visible=false ) => {
        var collapseFunction = () => {
            this.setState( ( altState ) => {
                altState.isRowOpen[ category.id ] = !altState.isRowOpen[ category.id ];
                return altState;
            } );
        };
        var props = {
            isOpen: this.state.isRowOpen[ category.id ],
            key: 'category-' + category.id,
            category,
            parents,
            visible,
            onToggle: collapseFunction,
        };
        return ( <Row { ...props } /> );
    }
    convertToRows = ( rowData={}, parents=[], visible=false ) => {
        var rows = [];
        rows.push( this.renderRow( rowData, parents, visible ) );

        var showChildren = visible && this.state.isRowOpen[ rowData.id ];
        for( var i = 0; i < rowData.child_categories.length; i++ ) {
            rows.push( ...this.convertToRows( rowData.child_categories[i], [ ...parents, rowData.id ], showChildren ) );
        }
        return rows;
    }

    arrayTableRows = ( categories ) => {
        var rows = [];
        for( var i = 0; i < categories.length; i++ ) {
            rows.push( ...this.convertToRows( categories[ i ], [], true ) );
        }

        const currentSort = this.props.currentSort;
        const sortIcon = ( value ) => {
            if( currentSort == value ) {
                return (
                    <Icon source='fontAwesome'
                    icon='fas/faSortUp'
                    style={ { cursor: 'pointer' } }
                    onClick={ () => { this.props.onColumnSort( value ); } } />
                );
            }
            if( currentSort == `-${ value }` ) {
                return (
                    <Icon source='fontAwesome'
                    icon='fas/faSortDown'
                    style={ { cursor: 'pointer' } }
                    onClick={ () => { this.props.onColumnSort( value ); } } />
                );
            }
            return (
                <Icon source='fontAwesome'
                icon='fas/faSort'
                style={ { cursor: 'pointer' } }
                onClick={ () => { this.props.onColumnSort( value ); } } />
            );
        };
        rows.unshift( (
            <li className={ style.tableRow + ' dl-table-head' } key='-1'>
                <div className={ style.tableCell }>
                    CATEGORY NAME { sortIcon( 'name,child_categories.name' ) }
                </div>
                <div className={ style.tableCell } >
                    CONTENT COUNT
                </div>
                <div className={ style.tableCell } >
                    PRODUCT COUNT
                </div>
                <div className={ style.tableCell } >
                    STATUS { sortIcon( 'status,child_categories.status' ) }
                </div>
                <div className={ style.tableCell + ' ' + style.actionsCell } >ACTIONS</div>
            </li>
        ) );

        return rows;
    }
}
CategoriesTable.defaultProps = {
    onCategoryUpdated: ()=>{},
};

const mapDispatchToProps = () => {
    return {
        updateCategory: ( interestid, data ) => {
            return dAPI.patch( `/interests/${ interestid }`, data );
        },
    };
};

export default connect( null, mapDispatchToProps )( CategoriesTable );
